import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  /**
   * Store
   */
  reduce_customer: ['customer'],
  reduce_contacts: ['contacts'],
  reduce_consents: ['consents'],
  reduce_language: ['language'],
  reduce_nations: ['nations'],
  reduce_districts: ['districts'],
  reduce_municipalities: ['municipalities'],
  reduce_localities: ['localities'],
  reduce_caps: ['caps'],
  reduce_toponyms: ['toponyms'],
  reduce_addresses: ['addresses'],
  reduce_associated_customers: ['associated_customers'],
  reduce_check_registration_data: ['check_registration_data'],
  reduce_verify_registration_otp: ['verify_registration_otp'],
  reduce_history_addresses: ['history_addresses'],
  reduce_history_requests: ['history_requests'],
  reduce_policies: ['policies'],
  reduce_connexa_agencies: ['connexa_agencies'],
  reduce_policy_detail: ['policy_detail'],
  reduce_public_authority_policy: ['public_authority_policy'],
  reduce_documents: ['documents'],
  reduce_plurifonds_documents: ['plurifonds_documents'],
  reduce_plurifonds_mapped_documents: ['plurifonds_mapped_documents'],
  reduce_documents_errors: ['documents_errors'],
  reduce_documents_policy: ['documents_policy'],
  reduce_documents_institutional: ['documents_institutional'],
  reduce_public_documents: ['public_documents'],
  reduce_document: ['document'],
  reduce_plurifonds_document: ['plurifonds_document'],
  reduce_agencies: ['agencies'],
  reduce_vouchers: ['vouchers'],
  reduce_voucher_document: ['voucher_document'],
  reduce_policies_assistance: ['policies_assistance'],
  reduce_poll: ['poll'],
  reduce_dati_contraente: ['dati_contraente'],
  reduce_decoded_datamatrix: ['decoded_datamatrix'],
  reduce_verify_coverage: ['verify_coverage'],
  reduce_policies_max_suspension_date: ['policies_max_suspension_date'],
  /**
   * Sagas
   */
  saga_resolve_customer: [],
  saga_resolve_contacts: ['args'],
  saga_resolve_consents: [],
  saga_resolve_language: [],
  saga_resolve_nations: ['args'],
  saga_resolve_districts: ['args'],
  saga_resolve_municipalities: ['args'],
  saga_resolve_localities: ['args'],
  saga_resolve_caps: ['args'],
  saga_resolve_toponyms: [],
  saga_resolve_addresses: ['args'],
  saga_resolve_associated_customers: ['args'],
  saga_check_registration_data: ['args'],
  saga_verify_registration_otp: ['args'],
  saga_resolve_history_addresses: ['args'],
  saga_resolve_policies: ['args'],
  saga_resolve_connexa_agencies: ['args'],
  saga_resolve_public_authority_policy: ['args'],
  saga_resolve_policy_detail: ['args'],
  saga_resolve_documents: ['args'],
  saga_resolve_plurifonds_documents: ['args'],
  saga_resolve_documents_policy: ['args'],
  saga_resolve_documents_institutional: ['args'],
  saga_resolve_public_documents: ['args'],
  saga_download_document: ['args'],
  saga_download_plurifonds_document: ['args'],
  saga_download_public_document: ['args'],
  saga_resolve_history_requests: ['args'],
  saga_resolve_agencies: ['args'],
  saga_resolve_vouchers: [],
  saga_download_voucher: ['args'],
  saga_resolve_policies_assistance: ['args'],
  saga_resolve_poll: ['args'],
  saga_retrieve_dati_contraente_from_num_polizza: ['args'],
  saga_retrieve_dati_contraente_from_num_polizza_vita: ['args'],
  saga_retrieve_dati_contraente_from_num_ordine: ['args'],
  saga_post_decode_datamatrix: ['args'],
  saga_verify_coverage: [],
  saga_resolve_policy_max_suspension_date: ['args'],
})

export const data_types = Types
export const data_creators = Creators
